import { render, staticRenderFns } from "./FeedSection.vue?vue&type=template&id=131f5412&"
import script from "./FeedSection.vue?vue&type=script&lang=ts&"
export * from "./FeedSection.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports